
import { gsap } from 'gsap';
import ScrollToPlugin from 'gsap/ScrollToPlugin'

gsap.registerPlugin(ScrollToPlugin)

window.addEventListener('frame-ready', init)

function init() {

    // Variable height links in heros
    const heroLinks = Array.from(document.querySelectorAll('.hero-tall + section .variable-height-link'))

    if(heroLinks.length > 0) {

        gsap.timeline()
        .to(heroLinks, {
            opacity: 1,
            translateX: 0,
            stagger: .15
        })
    }
}
